<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {DirectoryNode} from 'src/typings';
    import {getMediaViewerContext} from '../../../lib/mv-context';
    import {createEventDispatcher} from 'svelte';
    import {get} from 'svelte/store';
    import MvContextMenuDivider from './MvContextMenuDivider.svelte';
    import MvContextMenuTitle from './MvContextMenuTitle.svelte';
    import KpContextMenuButton from 'shared/components/kp-context-menu/KpContextMenuButton.svelte';
    import {
        handleDirectoryCreateClick,
        handleDirectoryCreateTextFileClick,
        handleDirectoryDeleteClick,
        handleDirectoryEditMetadataClick,
        handleDirectoryUploadLocalFilesClick
    } from '../../../lib/mv-file-explorer-handlers';

    export let directory: DirectoryNode;
    export let contentsOpen: boolean;

    const context = getMediaViewerContext();
    const localize = getLocalization();
    const dispatch = createEventDispatcher<{ 'toggle-contents-open': boolean }>();

    const handleToggleContentsOpenClick = () => {
        const fileExplorerViewType = get(context.fileExplorerViewType);

        if (fileExplorerViewType === 'grid') {
            context.setFileExplorerSelectedDirectory(directory);
            return;
        }

        dispatch('toggle-contents-open', !contentsOpen);
    };

    const handleDownloadAllDirectoryFiles = async () => {
        await context.service.downloadAllDirectoryFiles(directory);
    };
</script>

<MvContextMenuTitle>
    {localize(/* @kp-localization mediaviewer.fileExplorer.DirectoryContextLabel */ 'mediaviewer.fileExplorer.DirectoryContextLabel')}
</MvContextMenuTitle>

<MvContextMenuDivider/>

{#if context.canEdit}
    <KpContextMenuButton icon="edit"
                         on:click={() => handleDirectoryEditMetadataClick(context, directory)}>

        {localize(/* @kp-localization mediaviewer.fileExplorer.EditDirectory */ 'mediaviewer.fileExplorer.EditDirectory')}
    </KpContextMenuButton>
{/if}

<KpContextMenuButton icon={contentsOpen ? 'folder' : 'folder-open'}
                     on:click={handleToggleContentsOpenClick}>

    {contentsOpen
        ? localize(/* @kp-localization mediaviewer.fileExplorer.HideDirectoryContents */ 'mediaviewer.fileExplorer.HideDirectoryContents')
        : localize(/* @kp-localization mediaviewer.fileExplorer.ShowDirectoryContents */ 'mediaviewer.fileExplorer.ShowDirectoryContents')}
</KpContextMenuButton>

<KpContextMenuButton icon="download"
                     on:click={handleDownloadAllDirectoryFiles}>

    {localize(/* @kp-localization mediaviewer.fileExplorer.DownloadAllDirectoryFiles */ 'mediaviewer.fileExplorer.DownloadAllDirectoryFiles')}
</KpContextMenuButton>

{#if context.canEdit}
    <MvContextMenuDivider/>

    <KpContextMenuButton icon="cloud-upload"
                         on:click={() => handleDirectoryUploadLocalFilesClick(context, directory)}>

        {localize(/* @kp-localization mediaviewer.fileExplorer.UploadDirectoryFiles */ 'mediaviewer.fileExplorer.UploadDirectoryFiles')}
    </KpContextMenuButton>

    <KpContextMenuButton icon="add-folder"
                         on:click={() => handleDirectoryCreateClick(context, directory)}>

        {localize(/* @kp-localization mediaviewer.fileExplorer.CreateNewSubdirectory */ 'mediaviewer.fileExplorer.CreateNewSubdirectory')}
    </KpContextMenuButton>

    <KpContextMenuButton icon="add-document"
                         on:click={() => handleDirectoryCreateTextFileClick(context, directory)}>

        {localize(/* @kp-localization mediaviewer.fileExplorer.CreateNewTextFile */ 'mediaviewer.fileExplorer.CreateNewTextFile')}
    </KpContextMenuButton>

    {#if context.rootDirectory.id !== directory.id}
        <MvContextMenuDivider/>

        <KpContextMenuButton icon="remove-folder"
                             buttonStyle="danger"
                             on:click={() => handleDirectoryDeleteClick(context, directory)}>

            {localize(/* @kp-localization mediaviewer.fileExplorer.DeleteDirectory */ 'mediaviewer.fileExplorer.DeleteDirectory')}
        </KpContextMenuButton>
    {/if}
{/if}